import store from "@/store";
import api from '../api'
// import router from '@/router'

const inventory = {
    namespaced:true,
    store,
    state(){
        return {
            data:[],
        }
    },
    mutations:{
        data(state,payload){
            state.data = payload
        },
        store(state,payload){
            state.data.push(payload)
        },
        update(state,payload){
            state.data[payload.index] = payload.response
        },
        delete(state,payload){
            state.data.splice(payload, 1)
        },
    },
    actions:{
        data(context,payload){
            api.get(`/inventory`)
            .then((res) => {
                console.log(res)
                context.commit('data',res.data.data)
            })
        },
        store(context,payload){
            api.post(`/inventory`,payload.payload)
            .then((res) => {
                
                context.commit('store',res.data.data)

                this.dispatch({
                    type : "notification/snackbar",
                    data : {
                        type : "success",
                        content : res.data.message,
                        errorIcon:"mdi-check-bold"
                    }
                })
            })
        },
        update(context,payload){
            console.log(payload)

            api.put(`/inventory/${payload.id}`,payload.payload)
            .then((res) => {
                console.log(res)
                
                context.commit('update',{
                    index : payload.index,
                    response : res.data.data
                })

                this.dispatch({
                    type : "notification/snackbar",
                    data : {
                        type : "success",
                        content : res.data.message,
                        errorIcon:"mdi-check-bold"
                    }
                })
            })
        },
        delete(context,payload){
            console.log(payload)
            api.delete(`/inventory/${payload.id}`)
            .then((res) => {
                context.commit('delete',payload.index)

                this.dispatch({
                    type : "notification/snackbar",
                    data : {
                        type : "success",
                        content : res.data.message,
                        errorIcon:"mdi-check-bold"
                    }
                })
            })
        },
    },
    getters:{
        datas(state){
            return state.data
        }
    }

} 

export default inventory